// Shared component styles. Preserve selector order, style values, and caller overrides.
export const BLUE = "#3451F4";
export const PURPLE = "#9C4FFF";
export const BORDER = "#E5E7EB";
export const COUNT_BG = "#F2E9FF";
export const ACTIVE_COUNT_BG = "#EAF2FF";
export const TAB_FONT_FAMILY = "Be Vietnam Pro";
export const tabNavigationStyles = {
  labelWrapper: () => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 1,
    width: "100%",
    textAlign: "left",
    lineHeight: "24px"
  }),
  labelContent: ({
    active,
    contentSizedIndicator,
    contentSizedIndicatorOffset,
    contentSizedIndicatorHeight
  }) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 1,
    width: "auto",
    flex: "0 0 auto",
    position: "relative",
    ...(active && contentSizedIndicator ? {
      "&::after": {
        content: '""',
        position: "absolute",
        left: 0,
        right: 0,
        bottom: contentSizedIndicatorOffset,
        height: contentSizedIndicatorHeight,
        borderRadius: 999,
        backgroundColor: BLUE
      }
    } : {})
  }),
  labelText: ({
    labelSx
  }) => ({
    color: PURPLE,
    fontFamily: TAB_FONT_FAMILY,
    fontStyle: "normal",
    fontSize: 14,
    fontWeight: 400,
    lineHeight: "24px",
    textTransform: "capitalize !important",
    letterSpacing: 0,
    whiteSpace: "nowrap",
    ...labelSx
  }),
  countBadge: ({
    active,
    countSx
  }) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 18,
    px: 0.75,
    height: 18,
    borderRadius: 999,
    backgroundColor: active ? ACTIVE_COUNT_BG : COUNT_BG,
    color: PURPLE,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1,
    fontFamily: TAB_FONT_FAMILY,
    textTransform: "capitalize !important",
    letterSpacing: 0,
    ...countSx
  }),
  wrapper: ({
    borderBottom,
    dividerColor,
    wrapperSx
  }) => ({
    minWidth: 0,
    mb: "-2px",
    ...(borderBottom ? {
      borderBottom: `1px solid ${dividerColor}`
    } : {}),
    ...wrapperSx
  }),
  tabs: ({
    minHeight,
    tabGap,
    contentSizedIndicator,
    indicatorColor,
    indicatorHeight,
    indicatorBorderRadius,
    idleColor,
    activeColor,
    tabsSx
  }) => ({
    minHeight,
    maxWidth: "100%",
    overflow: "visible",
    "& .MuiTabs-flexContainer": {
      gap: tabGap
    },
    "& .MuiTabs-indicator": {
      backgroundColor: contentSizedIndicator ? "transparent" : indicatorColor,
      height: indicatorHeight,
      bottom: "2px",
      zIndex: 1,
      borderRadius: indicatorBorderRadius,
      transition: "left 280ms cubic-bezier(0.4, 0, 0.2, 1), width 280ms cubic-bezier(0.4, 0, 0.2, 1), transform 280ms cubic-bezier(0.4, 0, 0.2, 1)"
    },
    "& .MuiTab-root": {
      minHeight,
      textTransform: "capitalize !important",
      px: 0,
      minWidth: "auto",
      color: idleColor,
      opacity: 1,
      alignItems: "flex-start",
      justifyContent: "flex-start",
      textAlign: "left",
      fontFamily: TAB_FONT_FAMILY,
      fontStyle: "normal",
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "24px"
    },
    "& .MuiTab-root.Mui-selected": {
      color: `${activeColor} !important`
    },
    ...tabsSx
  })
};
